import React, { useState, useEffect } from "react";
import "../AddAnnouncement/AddAnnouncement.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";

const AddAnnouncement = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [errorAnnouncementTitle, setErrorAnnouncementTitle] = useState(false);
  const [AnnouncementTitle, setAnnouncementTitle] = useState("");
  const [AnnouncementDate, setAnnouncementDate] = useState("");
  const [AnnouncementDescription, setAnnouncementDescription] = useState("");
  const [AnnouncementDateError, setAnnouncementDateError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [AnnouncementDescriptionError, setAnnouncementDescriptionError] =
    useState(false);

  const AnnouncementToken = GetToken();

  const validate = () => {
    if (!AnnouncementTitle) {
      setErrorAnnouncementTitle("userAnnouncementTitle");
      return false;
    }
    if (!AnnouncementDate) {
      setAnnouncementDateError("userAnnouncementDate");
      return false;
    }
    if (!AnnouncementDescription) {
      setAnnouncementDescriptionError("userAnnouncementDescription");
      return false;
    }
    return true;
  };

  const SaveAnnouncement = () => {
    if (!validate()) return;

    setLoading(true);

    const data = {
      AnnouncementTitle,
      Description: AnnouncementDescription,
      FlashTillDate: AnnouncementDate,
    };

    axios({
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${AnnouncementToken}`,
      },
      url: `${Apiurl()}/Admin/SaveAnnouncement`,
      data: { data: JSON.stringify(data) },
    })
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setAnnouncementTitle("");
          setAnnouncementDate("");
          setAnnouncementDescription("");
          setErrorAnnouncementTitle("");
          setAnnouncementDateError("");
          setAnnouncementDescriptionError("");
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleCancelButton = () => {
    setAnnouncementTitle("");
    setAnnouncementDate("");
    setAnnouncementDescription("");
    setErrorAnnouncementTitle("");
    setAnnouncementDateError("");
    setAnnouncementDescriptionError("");
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-page-annoucement"
              : "main-container-of-all-employees-page-annoucement-new"
          }
        >
          <div className="inner-container-of-all-employees-page">
            <div className="header-of-employees-page row">
              <div className="all-employee-text-annoucement col">
                <h4>Add Announcement</h4>
              </div>

              <div className="all-employees-directory-annoucement col">
                <div className="home-icon-header-annoucement">
                  <BiHomeAlt />
                </div>
                <div className="arrow-icon-header-annoucement">
                  <MdKeyboardArrowRight />
                </div>
                <div className="employee-text-header-annoucement">
                  <p>Dashboard</p>
                </div>
                <div className="arrow-icon-header-profile">
                  <MdKeyboardArrowRight />
                </div>
                <div className="all-employee-text-header-annoucement">
                  <p>Add Announcement</p>
                </div>
              </div>
            </div>
          </div>

          <div className="main-container-for-security-annoucement">
            <div className="outer-div-of-username-password-annoucement">
              <div className="username-password-annoucement">
                <div className="announcement-top-row">
                  <div className="announcement-field announcement-field-no-label">
                    <input
                      type="text"
                      value={AnnouncementTitle}
                      onChange={(e) => setAnnouncementTitle(e.target.value)}
                      placeholder="Announcement Title"
                    />

                    {errorAnnouncementTitle === "userAnnouncementTitle" &&
                    !AnnouncementTitle ? (
                      <span className="AnnouncementTitle-error">
                        Announcement Title is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="announcement-field">
                    <label>Flash Till Date</label>
                    <input
                      type="date"
                      value={AnnouncementDate}
                      onChange={(e) => setAnnouncementDate(e.target.value)}
                    />

                    {AnnouncementDateError === "userAnnouncementDate" &&
                    !AnnouncementDate ? (
                      <span className="AnnouncementTitle-error">
                        Flash Till Date is required.
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="password-floating-annoucement">
                  <textarea
                    cols="30"
                    rows="8"
                    placeholder="Description"
                    value={AnnouncementDescription}
                    spellCheck={false}
                    autoCorrect="off"
                    autoComplete="off"
                    data-gramm="false"
                    data-gramm_editor="false"
                    data-enable-grammarly="false"
                    onChange={(e) =>
                      setAnnouncementDescription(e.target.value)
                    }
                  ></textarea>

                  {AnnouncementDescriptionError ===
                    "userAnnouncementDescription" &&
                  !AnnouncementDescription ? (
                    <span className="AnnouncementTitle-er">
                      Description is required.
                    </span>
                  ) : null}

                  <div className="save-button-in-setting-annoucement">
                    <button
                      className="save-button-in-setting-annoucement-button-one"
                      onClick={SaveAnnouncement}
                    >
                      Submit
                    </button>

                    <button
                      onClick={handleCancelButton}
                      className="save-button-in-setting-annoucement-button-two"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAnnouncement;